import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router';
import { orderBy } from 'lodash';
import { SpeakersConsumer } from '../../contexts/SpeakersContext';
import SpeakerCard from './components/SpeakerCard';
import './Speakers.scss';

export const Speakers = ({
  isLoading,
  speakers,
  loadSpeakers,
  selectedSpeaker,
  setSelectedSpeaker
}) => {
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const orderedSpeakers = orderBy(speakers, ['featured'], ['desc']);

  const featuredSpeakers = orderBy(
    orderedSpeakers.filter(({ featured }) => featured === true),
    ['order'],
    ['desc']
  );
  const restOfSpeakers = orderBy(
    orderedSpeakers.filter(({ featured }) => featured === false),
    ['order'],
    ['desc']
  );

  useEffect(() => {
    loadSpeakers();
    if (pathname === '/speakers') {
      if (history.action !== 'POP') {
        setSelectedSpeaker('');
        window.scrollTo(0, 0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSpeakersButtonClick = () => {
    history.push('/speakers');
  };

  return (
    <section
      className={`section ${pathname === '/speakers' ? 'speakers-section' : ''}`}
      id="speakers-featured">
      <div className="container">
        {pathname === '/speakers' ? (
          <div className="page-title">
            <h1>SPEAKERS</h1>
          </div>
        ) : (
          <h1 className="section-title">SPEAKERS</h1>
        )}
        {isLoading ? (
          <i className="fa fa-spinner fa-spin fa-3x fa-fw" style={{ color: '#7500c0' }} />
        ) : (
          <>
            <div className="columns is-variable is-mobile is-multiline">
              {featuredSpeakers.map(({ id, photo, name, company, shortDesc }) => (
                <SpeakerCard
                  key={id}
                  company={company}
                  id={id}
                  name={name}
                  onCardClick={setSelectedSpeaker}
                  photo={photo}
                  selectedSpeaker={selectedSpeaker}
                  shortDesc={shortDesc}
                />
              ))}
            </div>
            {pathname === '/speakers' ? (
              <div className="columns is-variable is-mobile is-multiline other-speakers">
                {restOfSpeakers.map(({ id, photo, name, company, shortDesc }) => (
                  <SpeakerCard
                    key={id}
                    company={company}
                    id={id}
                    name={name}
                    onCardClick={setSelectedSpeaker}
                    photo={photo}
                    selectedSpeaker={selectedSpeaker}
                    shortDesc={shortDesc}
                  />
                ))}
              </div>
            ) : null}
          </>
        )}
        {pathname !== '/speakers' ? (
          <button
            className="button is-large  "
            id="speakers-button"
            onClick={() => onSpeakersButtonClick()}
            type="button">
            More Speakers
          </button>
        ) : null}
      </div>
    </section>
  );
};

Speakers.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadSpeakers: PropTypes.func.isRequired,
  selectedSpeaker: PropTypes.string.isRequired,
  setSelectedSpeaker: PropTypes.func.isRequired,
  speakers: PropTypes.arrayOf(
    PropTypes.shape({
      company: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      shortDesc: PropTypes.string.isRequired
    })
  ).isRequired
};

const SpeakersContainer = props => (
  <SpeakersConsumer>
    {({ isLoading, speakers, loadSpeakers, selectedSpeaker, setSelectedSpeaker }) => (
      <Speakers
        isLoading={isLoading}
        loadSpeakers={loadSpeakers}
        selectedSpeaker={selectedSpeaker}
        setSelectedSpeaker={setSelectedSpeaker}
        speakers={speakers}
        {...props}
      />
    )}
  </SpeakersConsumer>
);

export default SpeakersContainer;
